import React from "react";

export default function Boutique() {
  return (
    <div className="container-fluid" id="Boutique">
      <iframe title="boutique" id="iframe-Boutique" src="https://www.helloasso.com/associations/la-course-du-petit-prince-la-cdpp/boutiques/vente-produits-la-cdpp/widget"></iframe>
    </div>
  );
}
